module.exports = __webpack_public_path__ + "img/1545341809.dd0aa289.jpg";